import { SyntheticEvent, useState } from "react";
import {
  GlossaryTextExceptionModel,
  glossaryTextExceptionApi,
} from "../../api/glossaryTextExceptionApi";
import { ValidationProblem, formErrors } from "../../api/backendApi";
import { Alert, Button, Form, Modal } from "react-bootstrap";

interface GlossaryTextExceptionModalProps {
  glossaryTextException: GlossaryTextExceptionModel;
  isCreate: boolean;
  onChange: (glossaryTextException: GlossaryTextExceptionModel) => void;
  onCancel: () => void;
  modalText: string;
}

function GlossaryTextExceptionModal({
  glossaryTextException: initialGlossaryTextException,
  isCreate,
  onChange,
  onCancel,
  modalText,
}: GlossaryTextExceptionModalProps) {
  const [glossaryTextException, setGlossaryTextException] =
    useState<GlossaryTextExceptionModel>(initialGlossaryTextException);
  const [errors, setErrors] = useState<formErrors>({});
  const [show, setShow] = useState<boolean>(true);

  const handleClose = () => {
    setShow(false);
    onCancel();
    setGlossaryTextException(initialGlossaryTextException);
  };

  const handleSubmit = (event: SyntheticEvent) => {
    event.preventDefault();

    let call = isCreate
      ? glossaryTextExceptionApi.createGlossaryTextException(
          glossaryTextException,
        )
      : glossaryTextExceptionApi.updateGlossaryTextException(
          initialGlossaryTextException.text,
          glossaryTextException,
        );

    call.then((result) => {
      if (result.ok) {
        onChange(glossaryTextException);
        handleClose();
      } else {
        let validation = result.problem as ValidationProblem;
        if (validation.validation) {
          setErrors(validation.validation);
        } else {
          let errors: formErrors = {};
          errors[""] = [
            `${result.problem.title} + [${result.problem.instance}]`,
          ];
        }
      }
    });
  };

  const handleChange = (event: any) => {
    const { name, value } = event.target;
    var change = null;

    change = { [name]: value };

    const modified: GlossaryTextExceptionModel = {
      ...glossaryTextException,
      ...change,
    };

    setGlossaryTextException(modified);
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{modalText}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit} id="templateTextForm">
            {errors[""] && (
              <div style={{ marginTop: "1rem" }}>
                {errors[""].map((errorMessage, index) => (
                  <Alert key={errorMessage} variant="danger">
                    <p key={index}>{errorMessage}</p>
                  </Alert>
                ))}
              </div>
            )}
            <Form.Group>
              <Form.Label>Text</Form.Label>
              <Form.Control
                name="text"
                type="text"
                value={glossaryTextException.text ?? ""}
                onChange={handleChange}
              />
              {errors.text && (
                <div style={{ marginTop: "1rem" }}>
                  {errors.text.map((e, index) => (
                    <Alert key={e} variant="danger">
                      <p>{e}</p>
                    </Alert>
                  ))}
                </div>
              )}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" form="templateTextForm" type="submit">
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default GlossaryTextExceptionModal;
